import {AbstractType, getTemplate} from "./AbstractType";
import functionHtml from './function.html?raw';

export let template = getTemplate(functionHtml);

export class viewModel extends AbstractType {
}
